export const occupationsQueryKeys = {
  all: ["occupations"] as const,
  lists: () => [...occupationsQueryKeys.all, "list"] as const,
  list: (propertyTicker: string) => [...occupationsQueryKeys.lists(), { propertyTicker }] as const,
  configurations: (propertyTicker: string) =>
    [...occupationsQueryKeys.all, "configurations", { propertyTicker }] as const,
};
